import loadingIconAzul from "_assets/img/loading.png";
import loadingIconVemelho from "_assets/img/loading-red.png";
import loadingIconVerde from "_assets/img/loading-green.png";
import loadingIconLaranja from "_assets/img/loading-orange.png";
import loadingIconCinza from "_assets/img/loading-grey.png";
import { LoadingContainer } from "./style";

interface LoadingProps {
  mostrar: boolean;
  cor?: "azul" | "verde" | "vermelho" | "laranja" | "preto";
  height?: number;
}

const CorIcone = {
  azul: loadingIconAzul,
  vermelho: loadingIconVemelho,
  verde: loadingIconVerde,
  laranja: loadingIconLaranja,
  preto: loadingIconCinza,
};

export function LoadingCirculo({
  mostrar,
  cor = "preto",
  height = 2.4,
}: LoadingProps) {
  return (
    <LoadingContainer mostrar={mostrar} height={height}>
      <img src={CorIcone[cor]} alt="Loading" />
    </LoadingContainer>
  );
}
